import React from 'react';

const ValueMappings = ({
  valueMappings,
  loading,
  selectedEntityType,
  setSelectedEntityType,
  fetchValueMappings
}) => {
  // Group mappings by field
  const groupedMappings = valueMappings.reduce((acc, mapping) => {
    const key = `${mapping.autotask_field_id} ↔ ${mapping.hubspot_field_id}`;
    if (!acc[key]) acc[key] = [];
    acc[key].push(mapping);
    return acc;
  }, {});

  return (
    <div className="page-content">
      <div className="page-header">
        <div className="header-left">
          <h2>Value Mappings</h2>
          <p>HubSpot to Autotask picklist value mappings (read-only)</p>
        </div>
        <div className="header-actions">
          <select
            value={selectedEntityType}
            onChange={(e) => setSelectedEntityType(e.target.value)}
            className="entity-select"
          >
            <option value="Company">Company</option>
            <option value="Contact">Contact</option>
          </select>
          <button onClick={fetchValueMappings} className="btn btn-secondary" disabled={loading}>
            {loading ? 'Loading...' : 'Refresh'}
          </button>
        </div>
      </div>

      {loading ? (
        <div className="loading">Loading value mappings...</div>
      ) : (
        <div className="value-mappings-container">
          {Object.keys(groupedMappings).length === 0 ? (
            <div className="no-data-card">No value mappings found</div>
          ) : (
            Object.entries(groupedMappings).map(([fieldKey, mappings]) => (
              <div key={fieldKey} className="mapping-group">
                <h3 className="mapping-group-title">
                  {fieldKey}
                </h3>
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>Status</th>
                      <th>HubSpot Value</th>
                      <th></th>
                      <th>Autotask Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {mappings.map((mapping) => (
                      <tr key={mapping.id} className={!mapping.is_active ? 'inactive' : ''}>
                        <td>
                          <span className={`status-badge ${mapping.is_active ? 'success' : 'error'}`}>
                            {mapping.is_active ? 'Active' : 'Inactive'}
                          </span>
                        </td>
                        <td>
                          <code>{mapping.hubspot_value_id}</code>
                          <br />
                          <small className="text-muted">{mapping.hubspot_value_label}</small>
                        </td>
                        <td className="arrow-cell">→</td>
                        <td>
                          <code>{mapping.autotask_value_id}</code>
                          <br />
                          <small className="text-muted">{mapping.autotask_value_label}</small>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))
          )}
        </div>
      )}

      <div style={{
        marginTop: 24,
        padding: 16,
        background: '#f8f9fa',
        borderRadius: 8,
        border: '1px solid #e9ecef'
      }}>
        <h4 style={{margin: '0 0 8px 0', fontSize: 14, color: '#495057'}}>How Value Mappings Work</h4>
        <p style={{margin: 0, fontSize: 13, color: '#6c757d', lineHeight: 1.6}}>
          Value mappings translate picklist/dropdown values between HubSpot and Autotask.
          For example, a HubSpot lifecycle stage of "customer" maps to Autotask company type "1".
          These mappings ensure consistent data when syncing records between systems.
        </p>
      </div>
    </div>
  );
};

export default ValueMappings;
